import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SidebarTaskGroupUi } from 'src/app/routes/routes-with-sidebar/shared/components/sidebar/model/sidebar.model';

@Component({
  selector: 'ri-resolution-ui-review-group-template',
  templateUrl: './review-group-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewGroupTemplateComponent {
  readonly group = input.required<SidebarTaskGroupUi>();
}
